import React, { useState } from 'react';
import SearchBox from './SearchBox';
import ProductsListing from './ProductsListing';

const RightContentBox = ({ category, user_id }) => {
  const [query, setQuery] = useState('');
  const handleChangeQuery = (p) => setQuery(p);

  return (
    <div
      style={{
        flex: 0.8,
        marginLeft: 32
      }}
    >
      {' '}
      <SearchBox handleChangeQuery={handleChangeQuery} query={query} />
      <ProductsListing query={query} category={category} user_id={user_id} />
    </div>
  );
};

export default RightContentBox;
